module.exports = __webpack_public_path__ + "img/zizhi18.0655298a.png";